import React, { useState, useEffect } from 'react'
import Chart from 'react-google-charts'
import { useNavigate  } from 'react-router-dom'
import { findByShort } from '../../js/countries'
import { findByName, filterByCountry } from '../../js/states'

function RegionChart({ region }) {
  const navigate = useNavigate();
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  })

  const [statesData] = useState(() => {
    const country = findByShort(region)
    const states = filterByCountry(country.id)

    return [['State', 'Popularity'], ...states.map((state) => [state.name, 1])]
  })

  useEffect(() => {
    window.addEventListener('resize', onResize)
    onResize()

    // TODO Fetch courses count per state
    // getStateCourseCountMap(state)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  const onResize = () => {
    const width = window.innerWidth
    setSize({
      width,
      height: (width * 5) / 9,
    })
  }

  const onStateSelected = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart()
    const selection = chart.getSelection()
    if (selection.length === 1) {
      const [selectedItem] = selection
      const { row } = selectedItem
      const dataTable = chartWrapper.getDataTable()
      const stateName = dataTable.getValue(row, 0)
      const state = findByName(stateName)
      navigate(`/country/${region}/${state.short}`)
    }
  }

  const { width, height } = size

  const options = {
    colors: ['#08c'],
    legend: 'none',
    tooltip: { trigger: 'none' },
    region,
    displayMode: 'regions',
    resolution: 'provinces',
  }

  if (width === 0 || height === 0) return null

  return (
    <Chart
      width={width}
      height={height}
      key={height /* triggers reload on resize window */}
      chartType="GeoChart"
      data={statesData}
      options={options}
      mapsApiKey={process.env.REACT_APP_CHARTS_KEY}
      chartEvents={[
        {
          eventName: 'select',
          callback: onStateSelected,
        },
      ]}
    />
  )
}

export default RegionChart
